const MapEmbed = () => {

    return (
        <div className="map-responsive"
        >
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1989.9444617750016!2d9.700992560773233!3d4.043082588347569!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1061133bac653229%3A0xbadb358c42e475a5!2sKEVO%20TELECOM!5e0!3m2!1sen!2scm!4v1780238460911!5m2!1sen!2scm"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                height={300}
            >
            </iframe>
        </div>
    );
};

export default MapEmbed;